import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import axios from 'axios';
import Header from '../components/Header';
import styles from './styles/Vendas.module.css';
import Link from '../components/Link';
import PageTitle from '../components/PageTitle';
import Loading from '../components/Loading/Index';
import ImageModal from 'react-modal';
import { FaChevronDown } from "react-icons/fa6";

function formatarValor(valor) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
}

function formatarMilhares(valor) {
  return new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 0
  }).format(valor);
}

const EMPRESAS_POR_SETOR = {
  ESCRITÓRIO: ["27", "29", "41", "42", "44", "45", "46", "47", "48", "300C", "410C", "411"],
  LOJA: ["200", "201", "300", "301", "302", "401", "410"],
  REPRESENTANTE: [
    "31", "32", "33", "34", "35", "36", "37", "38", "39",
    "40",
    "51", "52", "54", "55", "57", "58", "59",
    "61", "62", "63", "66", "69",
    "91", "92", "93", "94", "95", "96"
  ],
  SHOWROOM: ["50", "90", "400"],
};

const INITIAL_FILTERS = {
  setor: [],
  regiao: [],
  empresa: [],
  usuario: "",
  cliente: "",
  docto: "",
  tabelaPreco: "",
  periodoIni: "2026-01-01",
  periodoFim: "2026-12-31",
  exibir_almox: "nao",
  grupo: [],
  categoria1: [],
  categoria2: [],
  cod_item: "",
  descricao: "",
  fabricante: "",
  fornecedor: "",
  qtdeMin: "",
  qtdeMax: "",
  vlUnitMin: "",
  vlUnitMax: "",
  rankingOrdenacao: "valor"
};

function VendasAtacado() {
  const navigate = useNavigate();

  const usuario = localStorage.getItem('usuario');
  const usuarioId = localStorage.getItem("usuarioId");
  const permissoes = JSON.parse(localStorage.getItem('permissoes'));

  // helper: formata YYYY-MM-DD no fuso de SP (bom pra input type="date")
  const formatDateSP = (date) =>
    new Intl.DateTimeFormat("en-CA", { timeZone: "America/Sao_Paulo" }).format(date);

  const [filters, setFilters] = useState(INITIAL_FILTERS);
  const [empresas, setEmpresas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [fabricantes, setFabricantes] = useState([]);
  const [fornecedores, setFornecedores] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRegistros, setTotalRegistros] = useState(0);
  const [totalQtd, setTotalQtd] = useState(0);
  const [totalValor, setTotalValor] = useState(0);
  const [totalCusto, setTotalCusto] = useState(0);
  const [totalValorLiquido, setTotalValorLiquido] = useState(0);
  const [totalValorLiquido2, setTotalValorLiquido2] = useState(0);
  const [totalValorLiquido3, setTotalValorLiquido3] = useState(0);
  const [totalAtendimentos, setTotalAtendimentos] = useState(0);
  const [rankingEmpresas, setRankingEmpresas] = useState([]);
  const [rankingGruposPai, setRankingGruposPai] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);

  const limit = 50;

  const empresasPermitidas = useMemo(() => {
    const lista = permissoes?.vendas?.empresas_permitidas;
    return Array.isArray(lista) ? lista.map(String) : [];
  }, [permissoes]);

  useEffect(() => {
    if (empresasPermitidas.length !== 1) return;

    setFilters((prev) => {
      const atual = Array.isArray(prev.empresa)
        ? prev.empresa
        : prev.empresa
          ? [String(prev.empresa)]
          : [];

      if (atual.length > 0) return prev;

      return { ...prev, empresa: [empresasPermitidas[0]] };
    });
  }, [empresasPermitidas]);

  const fetchData = async (customFilters = filters, customPage = page) => {
    setIsLoading(true);

    try {
      const usuario = localStorage.getItem("usuario");
      const usuarioId = localStorage.getItem("usuarioId");

      const res = await axios.post(
        "https://provin.ind.br/api/vendas/atacado",
        {
          ...customFilters,
          page: customPage,
          limit
        },
        {
          params: {
            usuarioId // 👈 enviado como query param
          },
          headers: {
            "x-usuario": usuario
          }
        }
      );

      setResults(res.data.data);
      setTotalPages(res.data.totalPaginas);
      setTotalRegistros(res.data.totalRegistros);
      setTotalValor(res.data.totalValor);
      setTotalCusto(res.data.totalCusto);
      setTotalValorLiquido(res.data.totalValorLiquido);
      setTotalValorLiquido2(res.data.totalValorLiquido2);
      setTotalValorLiquido3(res.data.totalValorLiquido2 * 0.86);
      setTotalQtd(res.data.totalQtd);
      setTotalAtendimentos(res.data.totalAtendimentos);
      setRankingEmpresas(res.data.topEmpresas || []);
      setRankingGruposPai(res.data.topGruposPai || []);

      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      console.error("Erro ao buscar:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Se mudar empresa, limpa radio buttons específicos das empresas 400 e 403
  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      usuario: "",
    }));
  }, [filters.empresa]);

  const handleChange = (e) => {
    const { name, value, type, checked, multiple, options } = e.target;

    setFilters((prev) => {
      // Caso select múltiplo
      if (type === "select-multiple" || multiple) {
        const values = Array.from(options)
          .filter((opt) => opt.selected)
          .map((opt) => opt.value);
        return { ...prev, [name]: values };
      }

      // Caso checkbox (múltiplos valores possíveis)
      if (type === "checkbox") {
        const current = prev[name] || [];
        return {
          ...prev,
          [name]: checked
            ? [...current, value] // adiciona
            : current.filter((v) => v !== value), // remove
        };
      }

      // Caso radio (apenas 1 valor ativo)
      if (type === "radio") {
        return { ...prev, [name]: value };
      }

      // Input normal / select simples
      return { ...prev, [name]: value };
    });
  };

  // Select customizado (Empresa)
  const selectRef = useRef(null);
  const setorSelectRef = useRef(null);
  const regiaoSelectRef = useRef(null);
  const clienteSelectRef = useRef(null);
  const tabelaSelectRef = useRef(null);
  const fabricanteSelectRef = useRef(null);
  const fornecedorSelectRef = useRef(null);

  useEffect(() => {
    // quando trocar setor: limpa empresa + busca e fecha dropdown
    setFilters((prev) => ({ ...prev, empresa: [], cliente: "" }));
    setSearch("");
    setOpen(false);
  }, [filters.setor]);

  useEffect(() => {
    // quando trocar região: limpa empresa + busca e fecha dropdown
    setFilters((prev) => ({ ...prev, empresa: [], cliente: "" }));
    setSearch("");
    setOpen(false);
  }, [filters.regiao]);

  useEffect(() => {
    // quando trocar empresa: fecha select de cliente e limpa busca
    setOpenCliente(false);
    setSearchCliente("");
  }, [filters.empresa]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setOpen(false);
        setSearch("");
      }
      if (setorSelectRef.current && !setorSelectRef.current.contains(event.target)) {
        setOpenSetor(false);
      }
      if (regiaoSelectRef.current && !regiaoSelectRef.current.contains(event.target)) {
        setOpenRegiao(false);
      }
      if (clienteSelectRef.current && !clienteSelectRef.current.contains(event.target)) {
        setOpenCliente(false);
        setSearchCliente("");
      }
      if (tabelaSelectRef.current && !tabelaSelectRef.current.contains(event.target)) {
        setOpenTabela(false);
      }
      if (fabricanteSelectRef.current && !fabricanteSelectRef.current.contains(event.target)) {
        setOpenFabricante(false);
        setSearchFabricante("");
      }
      if (fornecedorSelectRef.current && !fornecedorSelectRef.current.contains(event.target)) {
        setOpenFornecedor(false);
        setSearchFornecedor("");
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [filtrosAbertos, setFiltrosAbertos] = useState(false);
  const [openSetor, setOpenSetor] = useState(false);
  const [openRegiao, setOpenRegiao] = useState(false);
  const [openCliente, setOpenCliente] = useState(false);
  const [searchCliente, setSearchCliente] = useState("");
  const [openTabela, setOpenTabela] = useState(false);
  const [openFabricante, setOpenFabricante] = useState(false);
  const [searchFabricante, setSearchFabricante] = useState("");
  const [openFornecedor, setOpenFornecedor] = useState(false);
  const [searchFornecedor, setSearchFornecedor] = useState("");

  const setores = [
    { value: "ESCRITÓRIO", label: "ESCRITÓRIO" },
    { value: "LOJA", label: "LOJA" },
    { value: "REPRESENTANTE", label: "REPRESENTANTE" },
    { value: "SHOWROOM", label: "SHOWROOM" }
  ];

  const regioes = [
    { value: "RS", label: "RS" },
    { value: "SC", label: "SC" },
    { value: "SP", label: "SP" },
    { value: "CE", label: "CE" }
  ];

  const tabelasPreco = [
    { value: "", label: "Valor Original do Documento" },
    { value: "10", label: "ATACADO" },
    { value: "6", label: "VAREJO" },
    { value: "7", label: "CONSULTORAS" },
    { value: "3", label: "S¹" },
    { value: "12", label: "S²" }
  ];

  // 1) lista base: empresas de acordo com o setor
  const empresasDoSetor = useMemo(() => {
    const setoresSelecionados = Array.isArray(filters.setor)
      ? filters.setor.filter(Boolean)
      : filters.setor
        ? [filters.setor]
        : [];
    const regioesSelecionadas = Array.isArray(filters.regiao)
      ? filters.regiao.filter(Boolean).map((r) => String(r).toUpperCase())
      : filters.regiao
        ? [String(filters.regiao).toUpperCase()]
        : [];

    let listaEmpresas = empresas;

    if (setoresSelecionados.length) {
      const permitidas = [...new Set(
        setoresSelecionados.flatMap((setor) => EMPRESAS_POR_SETOR[setor] || [])
      )];

      // compara codigo como string para bater com o map
      listaEmpresas = listaEmpresas.filter((e) => permitidas.includes(String(e.codigo)));
    }

    if (regioesSelecionadas.length) {
      listaEmpresas = listaEmpresas.filter((e) =>
        regioesSelecionadas.includes(String(e.regiao || "").toUpperCase())
      );
    }

    return listaEmpresas;
  }, [empresas, filters.setor, filters.regiao]);

  // 2) lista final: aplica busca em cima da lista do setor
  const empresasFiltradas = useMemo(() => {
    const q = search.trim().toLowerCase();
    if (!q) return empresasDoSetor;

    return empresasDoSetor.filter((e) =>
      `${e.codigo} ${e.nome}`.toLowerCase().includes(q)
    );
  }, [empresasDoSetor, search]);

  const clientesFiltrados = useMemo(() => {
    const q = searchCliente.trim().toLowerCase();
    if (!q) return clientes;

    return clientes.filter((c) =>
      String(c.cliente || "").toLowerCase().includes(q)
    );
  }, [clientes, searchCliente]);

  const fabricantesFiltrados = useMemo(() => {
    const q = searchFabricante.trim().toLowerCase();
    if (!q) return fabricantes;

    return fabricantes.filter((f) =>
      String(f.nome_fabricante || "").toLowerCase().includes(q)
    );
  }, [fabricantes, searchFabricante]);

  const fornecedoresFiltrados = useMemo(() => {
    const q = searchFornecedor.trim().toLowerCase();
    if (!q) return fornecedores;

    return fornecedores.filter((f) =>
      String(f.fantasia || "").toLowerCase().includes(q)
    );
  }, [fornecedores, searchFornecedor]);

  function handleCustomSelect(value) {
    handleChange({
      target: {
        name: "empresa",
        value: String(value),
      }
    });

    setOpen(false);
    setSearch("");
  }

  const setorLabel = useMemo(() => {
    const sel = Array.isArray(filters.setor) ? filters.setor.filter(Boolean) : [];
    if (!sel.length) return "Todos";

    if (sel.length === 1) {
      const setor = setores.find((s) => s.value === sel[0]);
      return setor?.label || sel[0];
    }

    return `${sel.length} selecionados`;
  }, [filters.setor]);

  const regiaoLabel = useMemo(() => {
    const sel = Array.isArray(filters.regiao) ? filters.regiao.filter(Boolean) : [];
    if (!sel.length) return "Todas";

    if (sel.length === 1) return sel[0];

    return `${sel.length} selecionadas`;
  }, [filters.regiao]);

  function handleClienteSelect(value) {
    handleChange({
      target: {
        name: "cliente",
        value: String(value),
      }
    });

    setOpenCliente(false);
    setSearchCliente("");
  }

  function handleTabelaSelect(value) {
    handleChange({
      target: {
        name: "tabelaPreco",
        value: String(value),
      }
    });

    setOpenTabela(false);
  }

  function handleFabricanteSelect(value) {
    handleChange({
      target: {
        name: "fabricante",
        value: String(value),
      }
    });

    setOpenFabricante(false);
    setSearchFabricante("");
  }

  function handleFornecedorSelect(value) {
    handleChange({
      target: {
        name: "fornecedor",
        value: String(value),
      }
    });

    setOpenFornecedor(false);
    setSearchFornecedor("");
  }

  // Atalhos para o período no filtro
  const [anoSelecionado, setAnoSelecionado] = useState(null);
  const [mesSelecionado, setMesSelecionado] = useState(null); // 0–11
  // const [atalhoMes, setAtalhoMes] = useState(null); // "mesAnterior" | "mesAtual"

  const [anoAtalho, setAnoAtalho] = useState(new Date().getFullYear()); // Ano atualmente "selecionado" para os atalhos dos meses

  const anos = [2023, 2024, 2025, 2026];
  const meses = [
    { label: "Jan", idx: 0 },
    { label: "Fev", idx: 1 },
    { label: "Mar", idx: 2 },
    { label: "Abr", idx: 3 },
    { label: "Mai", idx: 4 },
    { label: "Jun", idx: 5 },
    { label: "Jul", idx: 6 },
    { label: "Ago", idx: 7 },
    { label: "Set", idx: 8 },
    { label: "Out", idx: 9 },
    { label: "Nov", idx: 10 },
    { label: "Dez", idx: 11 },
  ];

  const setAno = (ano) => {
    setAnoSelecionado(ano);
    setMesSelecionado(null);
    // setAtalhoMes(null);
    setAnoAtalho(ano);

    const inicio = new Date(ano, 0, 1);
    const fim = new Date(ano, 11, 31);

    setFilters((prev) => ({
      ...prev,
      periodoIni: formatDateSP(inicio),
      periodoFim: formatDateSP(fim),
    }));
  };

  const setMesPorIndice = (mesIdx) => {
    setMesSelecionado(mesIdx);
    // setAtalhoMes(null);

    const inicio = new Date(anoAtalho, mesIdx, 1);
    const fim = new Date(anoAtalho, mesIdx + 1, 0);

    setFilters((prev) => ({
      ...prev,
      periodoIni: formatDateSP(inicio),
      periodoFim: formatDateSP(fim),
    }));
  };

  // const setMes = (tipo) => {
  //   setAtalhoMes(tipo);
  //   setMesSelecionado(null);
  //   setAnoSelecionado(null);

  //   const hoje = new Date();
  //   let inicio, fim;

  //   if (tipo === "mesAnterior") {
  //     inicio = new Date(hoje.getFullYear(), hoje.getMonth() - 1, 1);
  //     fim = new Date(hoje.getFullYear(), hoje.getMonth(), 0);
  //   } else {
  //     inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
  //     fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);
  //   }

  //   setAnoAtalho(inicio.getFullYear());

  //   setFilters((prev) => ({
  //     ...prev,
  //     periodoIni: formatDateSP(inicio),
  //     periodoFim: formatDateSP(fim),
  //   }));
  // };

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    setFiltrosAbertos(false);
    fetchData(filters, 1);
  };

  const handleToggleRankingOrdenacao = () => {
    const proximaOrdenacao = filters.rankingOrdenacao === "qtd" ? "valor" : "qtd";
    const novosFiltros = { ...filters, rankingOrdenacao: proximaOrdenacao };
    setFilters(novosFiltros);
    fetchData(novosFiltros, 1);
    setPage(1);
  };

  const handleDownloadExcel = async () => {
    setIsDownloading(true);
    try {
      const usuario = localStorage.getItem("usuario");
      const res = await axios.post(
        "https://provin.ind.br/api/vendas/atacado/exportar",
        filters,
        {
          headers: {
            "x-usuario": usuario
          },
          responseType: "blob"
        }
      );

      const blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = `vendas_${new Date().toISOString().slice(0, 10)}.xlsx`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Erro ao exportar:", err);
    } finally {
      setIsDownloading(false);
    }
  };

  // Atualiza resultados ao mudar de página
  useEffect(() => {
    fetchData(filters, page);
  }, [page]);

  // Carregar empresas ao montar
  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const res = await axios.get("https://provin.ind.br/api/vendas/atacado/empresas", {
          params: { usuarioId }
        });
        setEmpresas(res.data);
      } catch (err) {
        console.error("Erro ao buscar empresas:", err);
      }
    };
    fetchEmpresas();
  }, []);

  // Carregar clientes quando empresa mudar
  useEffect(() => {
    if (!Array.isArray(filters.empresa) || filters.empresa.length !== 1) {
      setClientes([]);
      return;
    }

    const fetchClientes = async () => {
      try {
        const res = await axios.get(`https://provin.ind.br/api/vendas/atacado/clientes/${filters.empresa[0]}`);
        setClientes(res.data);
      } catch (err) {
        console.error("Erro ao buscar clientes:", err);
      }
    };
    fetchClientes();
  }, [filters.empresa]);

  // Carregar fabricantes ao montar
  useEffect(() => {
    const fetchFabricantes = async () => {
      try {
        const res = await axios.get("https://provin.ind.br/api/vendas/atacado/fabricantes");
        setFabricantes(res.data);
      } catch (err) {
        console.error("Erro ao buscar fabricantes:", err);
      }
    };
    fetchFabricantes();
  }, []);

  // Carregar fornecedores ao montar
  useEffect(() => {
    const fetchFornecedores = async () => {
      try {
        const res = await axios.get("https://provin.ind.br/api/vendas/atacado/fornecedores");
        setFornecedores(res.data);
      } catch (err) {
        console.error("Erro ao buscar fornecedores:", err);
      }
    };
    fetchFornecedores();
  }, []);

  const handleLimparFiltros = async () => {
    setFilters(INITIAL_FILTERS);

    // zera visuais dos botões de atalho para período (active)
    setAnoSelecionado(null);
    setMesSelecionado(null);
    // setAtalhoMes(null);

    setPage(1);
    fetchData(INITIAL_FILTERS, 1);
  };

  // Abrir a imagem do produto em um modal ampliado
  useEffect(() => {
    ImageModal.setAppElement('#root');
  }, []);
  const [modalAberto, setModalAberto] = useState(false);
  const [imagemSelecionada, setImagemSelecionada] = useState('');
  const abrirModal = (caminhoImagem) => {
    setImagemSelecionada(caminhoImagem);
    setModalAberto(true);
  };
  const fecharModal = () => {
    setModalAberto(false);
  };

  // Ano visível acima dos valores/qtd vendidos
  let anoVisivel = null;
  if (filters.periodoIni === "2026-01-01" && filters.periodoFim === "2026-12-31") {
    anoVisivel = 2026;
  } else if (filters.periodoIni === "2025-01-01" && filters.periodoFim === "2025-12-31") {
    anoVisivel = 2025;
  } else if (filters.periodoIni === "2024-01-01" && filters.periodoFim === "2024-12-31") {
    anoVisivel = 2024;
  } else if (filters.periodoIni === "2023-01-01" && filters.periodoFim === "2023-12-31") {
    anoVisivel = 2023;
  }

  // Ranking de clientes por empresa
  const [empresasOpen, setEmpresasOpen] = useState({});
  const toggleEmpresa = (codigo) => {
    setEmpresasOpen((s) => ({ ...s, [codigo]: !s[codigo] }));
  };
  const [gruposPaiOpen, setGruposPaiOpen] = useState({});
  const toggleGrupoPai = (grupoPai) => {
    setGruposPaiOpen((s) => ({ ...s, [grupoPai]: !s[grupoPai] }));
  };

  const maxRankingEmpresas = useMemo(() => {
    const valores = rankingEmpresas.map((x) =>
      Number(filters.rankingOrdenacao === "qtd" ? x.total_qtd : x.total_valor) || 0
    );
    return Math.max(...valores, 1);
  }, [rankingEmpresas, filters.rankingOrdenacao]);

  const maxRankingGruposPai = useMemo(() => {
    const valores = rankingGruposPai.map((x) =>
      Number(filters.rankingOrdenacao === "qtd" ? x.total_qtd : x.total_valor) || 0
    );
    return Math.max(...valores, 1);
  }, [rankingGruposPai, filters.rankingOrdenacao]);

  const empresaLabel = useMemo(() => {
    const sel = filters.empresa || [];
    if (!sel.length) return "Todas";

    if (sel.length === 1) {
      const achada = empresasDoSetor.find(e => String(e.codigo) === String(sel[0]));
      return achada ? `${achada.nome} (${achada.codigo})` : sel[0];
    }

    return `${sel.length} selecionadas`;
  }, [filters.empresa, empresasDoSetor]);

  // Funçaão para exibir o Custo da Mercadoria e Margem de Lucro apenas para os escritórios
  const empresasPermitidasCustoMargem = new Set(["41", "46", "45", "44", "47", "300C", "42", "48", "411", "29", "410C", "27"]);
  const empresasValidasCustoMargem =
    Array.isArray(filters?.empresa) &&
    filters.empresa.length > 0 &&
    filters.empresa.every(emp => empresasPermitidasCustoMargem.has(String(emp)));

  // Modal solicitação de produtos
  const [modalSolicitar, setModalSolicitar] = useState(false);
  const [produtoSelecionado, setProdutoSelecionado] = useState(null);
  const [qtdSolicitada, setQtdSolicitada] = useState(1);
  const [anotacao, setAnotacao] = useState("");

  const abrirSolicitacao = (item) => {
    setProdutoSelecionado(item);
    setQtdSolicitada(1);
    setAnotacao("");
    setModalSolicitar(true);
  };

  const enviarSolicitacao = async () => {
    try {
      const userId = localStorage.getItem("usuarioId");

      const response = await axios.post(
        "https://provin.ind.br/api/solicitacoes_distribuicao",
        {
          userId,
          cod_item: produtoSelecionado.cod_item,
          qtd: Number(qtdSolicitada),
          anotacao
        }
      );

      console.log(response.data);
      setModalSolicitar(false);
      alert("Solicitação enviada!");

    } catch (err) {
      console.error(err.response?.data || err.message);
    }
  };

  return (
    <div className={styles.body}>
      <Header />

      <Link redirectTo="/home" />

      <div className={styles.container}>
        <PageTitle src="/images/common/dinheiro.svg" title="Vendas" />

        <div className={styles.pageGrid}>
          <aside className={styles.filtersPanel}>
            <form className={styles.form} onSubmit={handleSearch}>
              <div className={styles.formHeader}>
                <div>
                  <h2>Filtros de pesquisa</h2>
                  <p className={styles.formSubtitle}>
                    Refine por venda, cliente e produto para encontrar os dados certos.
                  </p>
                </div>

                <div className={styles.formButtons}>
                  <button type="button" className={styles.btnLimparFiltros} onClick={handleLimparFiltros}>Limpar filtros</button>
                  <button type="submit" className={styles.button}>Pesquisar</button>
                </div>
              </div>

              <button
                type="button"
                className={styles.filtrosToggle}
                onClick={() => setFiltrosAbertos((prev) => !prev)}
                aria-expanded={filtrosAbertos}
              >
                {filtrosAbertos ? "Ocultar filtros" : "Mostrar filtros"}
              </button>

              <div className={`${styles.filtrosConteudo} ${filtrosAbertos ? styles.filtrosAbertos : ""}`}>
                <section className={styles.filterSection}>
                  <div className={styles.sectionHeader}>
                    <h3>Venda</h3>
                    <span>Empresa, cliente e período</span>
                  </div>

                  <div className={styles.fieldGrid}>
                    {(permissoes?.vendas?.empresas_permitidas?.length > 1 && !usuario.startsWith("escritorio") && !usuario.startsWith("loja") && usuario !== "showroomse") && (
                      <div className={styles.field} ref={setorSelectRef}>
                        <label>Setor</label>

                        {/* Select real (oculto) */}
                        <select
                          name="setor"
                          value={filters.setor || []}
                          multiple
                          onChange={handleChange}
                          className={styles.hiddenSelect}
                        >
                          <option value="">Todos</option>
                          {setores.map((setor) => (
                            <option key={setor.value} value={setor.value}>
                              {setor.label}
                            </option>
                          ))}
                        </select>

                        {/* Select customizado (visível) */}
                        <div
                          className={styles.customSelect}
                          onClick={() => setOpenSetor((prev) => !prev)}
                        >
                          <span>{setorLabel}</span>
                          <span className={styles.arrow}>▾</span>
                        </div>

                        {openSetor && (
                          <div className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                            <div className={styles.actionsRow}>
                              <button
                                type="button"
                                className={styles.actionBtn}
                                onClick={() => setFilters((prev) => ({ ...prev, setor: [] }))}
                              >
                                Limpar
                              </button>

                              <button
                                type="button"
                                className={styles.actionBtn}
                                onClick={() =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    setor: setores.map((s) => s.value),
                                  }))
                                }
                              >
                                Marcar tudo
                              </button>
                            </div>

                            <ul className={styles.options}>
                              {setores.map((setor) => (
                                <li key={setor.value} className={styles.optionItem}>
                                  <label className={styles.checkboxLabel}>
                                    <input
                                      type="checkbox"
                                      name="setor"
                                      value={setor.value}
                                      checked={(filters.setor || []).includes(setor.value)}
                                      onChange={handleChange}
                                    />
                                    <span className={styles.optionText}>{setor.label}</span>
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    {(!usuario.startsWith("escritorio") && !usuario.startsWith("loja" && usuario !== "showroomse")) && (
                      <div className={styles.field} ref={regiaoSelectRef}>
                        <label>Região</label>

                        <select
                          name="regiao"
                          value={filters.regiao || []}
                          multiple
                          onChange={handleChange}
                          className={styles.hiddenSelect}
                        >
                          <option value="">Todas</option>
                          {regioes.map((regiao) => (
                            <option key={regiao.value} value={regiao.value}>
                              {regiao.label}
                            </option>
                          ))}
                        </select>

                        <div
                          className={styles.customSelect}
                          onClick={() => setOpenRegiao((prev) => !prev)}
                        >
                          <span>{regiaoLabel}</span>
                          <span className={styles.arrow}>▾</span>
                        </div>

                        {openRegiao && (
                          <div className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                            <div className={styles.actionsRow}>
                              <button
                                type="button"
                                className={styles.actionBtn}
                                onClick={() => setFilters((prev) => ({ ...prev, regiao: [] }))}
                              >
                                Limpar
                              </button>

                              <button
                                type="button"
                                className={styles.actionBtn}
                                onClick={() =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    regiao: regioes.map((r) => r.value),
                                  }))
                                }
                              >
                                Marcar tudo
                              </button>
                            </div>

                            <ul className={styles.options}>
                              {regioes.map((regiao) => (
                                <li key={regiao.value} className={styles.optionItem}>
                                  <label className={styles.checkboxLabel}>
                                    <input
                                      type="checkbox"
                                      name="regiao"
                                      value={regiao.value}
                                      checked={(filters.regiao || []).includes(regiao.value)}
                                      onChange={handleChange}
                                    />
                                    <span className={styles.optionText}>{regiao.label}</span>
                                  </label>
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    <div className={`${styles.field} ${styles.fullWidth}`} ref={selectRef}>
                      <label>Empresa</label>

                      {/* “Select” visível (abre/fecha) */}
                      <div
                        className={styles.customSelect}
                        onClick={() => setOpen((o) => !o)}
                        role="button"
                        tabIndex={0}
                      >
                        <span>{empresaLabel}</span>
                        <span className={styles.arrow}>▾</span>
                      </div>

                      {open && (
                        <div className={styles.dropdown} onClick={(e) => e.stopPropagation()}>
                          {/* Busca */}
                          <input
                            type="text"
                            placeholder="Pesquisar..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className={styles.searchInput}
                          />

                          {/* Ações rápidas */}
                          <div className={styles.actionsRow}>
                            <button
                              type="button"
                              className={styles.actionBtn}
                              onClick={() => setFilters((prev) => ({ ...prev, empresa: [] }))}
                            >
                              Limpar
                            </button>

                            <button
                              type="button"
                              className={styles.actionBtn}
                              onClick={() =>
                                setFilters((prev) => ({
                                  ...prev,
                                  empresa: empresasDoSetor.map((e) => String(e.codigo)),
                                }))
                              }
                            >
                              Marcar tudo
                            </button>
                          </div>

                          {/* Lista vertical com checkboxes */}
                          <ul className={styles.options}>
                            {empresasFiltradas.length === 0 && (
                              <li className={styles.noResult}>Nenhum resultado</li>
                            )}

                            {empresasFiltradas.map((e) => {
                              const code = String(e.codigo);
                              const checked = (filters.empresa || []).includes(code);

                              return (
                                <li key={code} className={styles.optionItem}>
                                  <label className={styles.checkboxLabel}>
                                    <input
                                      type="checkbox"
                                      name="empresa"
                                      value={code}
                                      checked={checked}
                                      onChange={handleChange}
                                    />
                                    <span className={styles.optionText}>
                                      {e.nome} ({code})
                                    </span>
                                  </label>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}

                      {/* Se somente a empresa 400 estiver selecionada, liberar subfiltros */}
                      {(filters.empresa || []).length === 1 && (filters.empresa || []).includes("400") && (
                        <div className={styles.radioButtonUsuario}>
                          <p>No Showroom Praça Sé, você deseja as vendas:</p>
                          <label>
                            <input
                              type="radio"
                              name="usuario"
                              value=""
                              checked={filters.usuario === ""}
                              onChange={handleChange}
                            />
                            Total
                          </label>

                          <label>
                            <input
                              type="radio"
                              name="usuario"
                              value="ATACADO"
                              checked={filters.usuario === "ATACADO"}
                              onChange={handleChange}
                            />
                            Somente Atacado
                          </label>

                          <label>
                            <input
                              type="radio"
                              name="usuario"
                              value="VAREJO"
                              checked={filters.usuario === "VAREJO"}
                              onChange={handleChange}
                            />
                            Somente Varejo
                          </label>
                        </div>
                      )}
                    </div>

                    {usuario !== "PROVIN" && (
                      <div className={styles.field} ref={clienteSelectRef}>
                        <label>Cliente</label>

                        {/* Select real (oculto) */}
                        <select
                          name="cliente"
                          value={filters.cliente || ""}
                          onChange={handleChange}
                          className={styles.hiddenSelect}
                          disabled={!Array.isArray(filters.empresa) || filters.empresa.length !== 1}
                        >
                          <option value="">Todos</option>
                          {clientes.map((c) => (
                            <option key={c.cliente} value={c.cliente}>
                              {c.cliente}
                            </option>
                          ))}
                        </select>

                        {/* Select customizado (visível) */}
                        <button
                          type="button"
                          className={styles.customSelect}
                          onClick={() => filters.empresa && setOpenCliente((prev) => !prev)}
                          disabled={!filters.empresa}
                        >
                          <span>{filters.cliente || "Todos"}</span>
                          <span className={styles.arrow}>▾</span>
                        </button>

                        {openCliente && (
                          <div className={styles.dropdown}>
                            <input
                              type="text"
                              placeholder="Pesquisar cliente..."
                              value={searchCliente}
                              onChange={(e) => setSearchCliente(e.target.value)}
                              className={styles.searchInput}
                              autoFocus
                            />
                            <ul className={styles.options}>
                              {clientesFiltrados.length === 0 && (
                                <li className={styles.noResult}>Nenhum resultado</li>
                              )}
                              <li onClick={() => handleClienteSelect("")}>Todos</li>
                              {clientesFiltrados.map((c) => (
                                <li
                                  key={c.cliente}
                                  onClick={() => handleClienteSelect(c.cliente)}
                                >
                                  {c.cliente}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}

                    <div className={`${styles.field} ${styles.fullWidth}`}>
                      <label>Período</label>

                      <div className={styles.periodInputs}>
                        <input
                          type="date"
                          name="periodoIni"
                          value={filters.periodoIni || ""}
                          onChange={handleChange}
                        />
                        <input
                          type="date"
                          name="periodoFim"
                          value={filters.periodoFim || ""}
                          onChange={handleChange}
                        />
                      </div>

                      <div className={styles.atalhosData}>
                        {/* Anos */}
                        <div className={styles.grupo}>
                          {anos.map((ano) => (
                            <button
                              key={ano}
                              type="button"
                              onClick={() => setAno(ano)}
                              className={anoSelecionado === ano ? styles.active : ""}
                            >
                              {ano}
                            </button>
                          ))}
                        </div>

                        {/* Meses */}
                        <div className={styles.grupo}>
                          {meses.map((m) => (
                            <button
                              key={m.idx}
                              type="button"
                              onClick={() => setMesPorIndice(m.idx)}
                              className={mesSelecionado === m.idx ? styles.active : ""}
                            >
                              {m.label}
                            </button>
                          ))}
                        </div>

                        {/* Mês anterior / atual */}
                        {/* <div className={styles.grupo}>
                          <button
                            type="button"
                            onClick={() => setMes("mesAnterior")}
                            className={atalhoMes === "mesAnterior" ? styles.active : ""}
                          >
                            Mês anterior
                          </button>
                          <button
                            type="button"
                            onClick={() => setMes("mesAtual")}
                            className={atalhoMes === "mesAtual" ? styles.active : ""}
                          >
                            Mês atual
                          </button>
                        </div> */}
                      </div>
                    </div>

                    {usuario !== "PROVIN" && (
                      <div className={styles.field}>
                        <label>Documento</label>
                        <input type="text" name="docto" value={filters.docto || ""} onChange={handleChange} />
                      </div>
                    )}

                    {usuario !== "PROVIN" && (
                      <div className={styles.field} ref={tabelaSelectRef}>
                        <label>Tabela de Preço</label>

                        {/* Select real (oculto) */}
                        <select
                          name="tabelaPreco"
                          value={filters.tabelaPreco || ""}
                          onChange={handleChange}
                          className={styles.hiddenSelect}
                        >
                          {tabelasPreco.map((tabela) => (
                            <option key={tabela.value || "original"} value={tabela.value}>
                              {tabela.label}
                            </option>
                          ))}
                        </select>

                        {/* Select customizado (visível) */}
                        <div
                          className={styles.customSelect}
                          onClick={() => setOpenTabela((prev) => !prev)}
                        >
                          <span>
                            {tabelasPreco.find((tabela) => tabela.value === (filters.tabelaPreco || ""))?.label ||
                              "Valor Original do Documento"}
                          </span>
                          <span className={styles.arrow}>▾</span>
                        </div>

                        {openTabela && (
                          <div className={styles.dropdown}>
                            <ul className={styles.options}>
                              {tabelasPreco.map((tabela) => (
                                <li
                                  key={tabela.value || "original"}
                                  onClick={() => handleTabelaSelect(tabela.value)}
                                >
                                  {tabela.label}
                                </li>
                              ))}
                            </ul>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </section>

                {usuario !== "PROVIN" && (
                  <section className={styles.filterSection}>
                    <div className={styles.sectionHeader}>
                      <h3>Produto</h3>
                      <span>Categoria, código e valores</span>
                    </div>

                    <div className={styles.fieldGrid}>
                      <div className={`${styles.field} ${styles.fullWidth}`}>
                        <label>Exibir Produtos do Almoxarifado?</label>
                        <div className={styles.radioButtonUsuario}>
                          <label>
                            <input
                              type="radio"
                              name="exibir_almox"
                              value="sim"
                              checked={filters.exibir_almox === "sim"}
                              onChange={handleChange}
                            />
                            Sim
                          </label>

                          <label>
                            <input
                              type="radio"
                              name="exibir_almox"
                              value="nao"
                              checked={filters.exibir_almox === "nao"}
                              onChange={handleChange}
                            />
                            Não
                          </label>
                        </div>
                      </div>

                      <div className={`${styles.field} ${styles.fullWidth}`}>
                        <label>Grupo</label>
                        <div className={styles.checkboxGroup}>
                          {[
                            { value: "ALIANÇA", label: "Aliança" },
                            { value: "ANEL", label: "Anel" },
                            { value: "BRINCO", label: "Brinco" },
                            { value: "CHOKER", label: "Choker" },
                            { value: "CONJUNTO", label: "Conjunto" },
                            { value: "FECHO", label: "Fecho" },
                            { value: "GARGANTILHA", label: "Gargantilha" },
                            { value: "PIERCING", label: "Piercing" },
                            { value: "PINGENTE", label: "Pingente" },
                            { value: "PULSEIRA", label: "Pulseira" },
                            { value: "TORNOZELEIRA", label: "Tornozeleira" },
                            { value: "TARRAXA", label: "Tarraxa" },
                            { value: "BOMBA", label: "Bomba" },
                            { value: "CANETA", label: "Caneta" },
                            { value: "CARTÃO PERSONALIZADO", label: "Cartão Pers." },
                            { value: "CARTEIRA", label: "Carteira" },
                            { value: "CUIA", label: "Cuia" },
                            { value: "GUARDA-CHUVA", label: "Guarda-Chuva" },
                            { value: "LENÇO", label: "Lenço" },
                            { value: "MALETA", label: "Maleta" },
                            { value: "NECESSAIRE", label: "Necessaire" },
                            { value: "PORTA-CARTÕES", label: "Porta-Cartões" },
                            { value: "PRODUTOS DIVERSOS", label: "Prod. Diversos" },
                            { value: "SOMBRINHA", label: "Sombrinha" },
                            { value: "RELÓGIO", label: "Relógio" },
                            { value: "BOLSA", label: "Bolsa" },
                            { value: "ÓCULOS", label: "Óculos" },
                            { value: "ALMOXARIFADO", label: "Almoxarifado" }
                          ].map((opt) => (
                            <label key={opt.value}>
                              <input
                                type="checkbox"
                                name="grupo"
                                value={opt.value}
                                checked={filters.grupo?.includes(opt.value) || false}
                                onChange={handleChange}
                              />
                              {opt.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className={styles.field}>
                        <label>Banho/Metal</label>
                        <div className={styles.checkboxGroup}>
                          {[
                            { value: " AU", label: "Ouro" },
                            { value: " RB", label: "Ródio Branco" },
                            { value: " RN", label: "Ródio Negro" },
                            { value: " PL", label: "Prata Leve" }
                          ].map((opt) => (
                            <label key={opt.value}>
                              <input
                                type="checkbox"
                                name="categoria1"
                                value={opt.value}
                                checked={filters.categoria1?.includes(opt.value) || false}
                                onChange={handleChange}
                              />
                              {opt.label}
                            </label>
                          ))}
                        </div>

                        <div className={styles.checkboxGroup}>
                          {[
                            { value: " AP", label: "Aço Puro" },
                            { value: " PP", label: "Prata Pura" },
                            { value: " OP", label: "Ouro Puro" }
                          ].map((opt) => (
                            <label key={opt.value}>
                              <input
                                type="checkbox"
                                name="categoria1"
                                value={opt.value}
                                checked={filters.categoria1?.includes(opt.value) || false}
                                onChange={handleChange}
                              />
                              {opt.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className={styles.field}>
                        <label>Composição</label>
                        <div className={styles.checkboxGroup}>
                          {[
                            { value: "CR ", label: "Cristal" },
                            { value: "LIS ", label: "Lisa" },
                            { value: "MP ", label: "Madrepérola" },
                            { value: "PD ", label: "Pedra" },
                            { value: "PÉR ", label: "Pérola" },
                            { value: "ZR ", label: "Zircônia" },
                            { value: "CORR ", label: "Correntaria" }
                          ].map((opt) => (
                            <label key={opt.value}>
                              <input
                                type="checkbox"
                                name="categoria2"
                                value={opt.value}
                                checked={filters.categoria2?.includes(opt.value) || false}
                                onChange={handleChange}
                              />
                              {opt.label}
                            </label>
                          ))}
                        </div>
                      </div>

                      <div className={styles.field}>
                        <label>Código</label>
                        <input type="text" name="cod_item" value={filters.cod_item || ""} onChange={handleChange} />
                      </div>

                      <div className={styles.field}>
                        <label>Descrição</label>
                        <input type="text" name="descricao" value={filters.descricao || ""} onChange={handleChange} />
                      </div>

                      {(!usuario.startsWith("escritorio") && !usuario.startsWith("loja") && usuario !== "showroomse") && (
                        <>
                          <div className={styles.field} ref={fabricanteSelectRef}>
                            <label>Fabricante</label>

                            {/* Select real (oculto) */}
                            <select
                              name="fabricante"
                              value={filters.fabricante || ""}
                              onChange={handleChange}
                              className={styles.hiddenSelect}
                            >
                              <option value="">Todos</option>
                              {fabricantes.map((e) => (
                                <option key={e.nome_fabricante} value={e.nome_fabricante}>
                                  {e.nome_fabricante}
                                </option>
                              ))}
                            </select>

                            {/* Select customizado (visível) */}
                            <button
                              type="button"
                              className={styles.customSelect}
                              onClick={() => setOpenFabricante((prev) => !prev)}
                            >
                              <span>{filters.fabricante || "Todos"}</span>
                              <span className={styles.arrow}>▾</span>
                            </button>

                            {openFabricante && (
                              <div className={styles.dropdown}>
                                <input
                                  type="text"
                                  placeholder="Pesquisar fabricante..."
                                  value={searchFabricante}
                                  onChange={(e) => setSearchFabricante(e.target.value)}
                                  className={styles.searchInput}
                                  autoFocus
                                />
                                <ul className={styles.options}>
                                  {fabricantesFiltrados.length === 0 && (
                                    <li className={styles.noResult}>Nenhum resultado</li>
                                  )}
                                  <li onClick={() => handleFabricanteSelect("")}>Todos</li>
                                  {fabricantesFiltrados.map((f) => (
                                    <li
                                      key={f.nome_fabricante}
                                      onClick={() => handleFabricanteSelect(f.nome_fabricante)}
                                    >
                                      {f.nome_fabricante}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>

                          <div className={styles.field} ref={fornecedorSelectRef}>
                            <label>Fornecedor</label>

                            {/* Select real (oculto) */}
                            <select
                              name="fornecedor"
                              value={filters.fornecedor || ""}
                              onChange={handleChange}
                              className={styles.hiddenSelect}
                            >
                              <option value="">Todos</option>
                              {fornecedores.map((e) => (
                                <option key={e.fantasia} value={e.fantasia}>
                                  {e.fantasia}
                                </option>
                              ))}
                            </select>

                            {/* Select customizado (visível) */}
                            <button
                              type="button"
                              className={styles.customSelect}
                              onClick={() => setOpenFornecedor((prev) => !prev)}
                            >
                              <span>{filters.fornecedor || "Todos"}</span>
                              <span className={styles.arrow}>▾</span>
                            </button>

                            {openFornecedor && (
                              <div className={styles.dropdown}>
                                <input
                                  type="text"
                                  placeholder="Pesquisar fornecedor..."
                                  value={searchFornecedor}
                                  onChange={(e) => setSearchFornecedor(e.target.value)}
                                  className={styles.searchInput}
                                  autoFocus
                                />
                                <ul className={styles.options}>
                                  {fornecedoresFiltrados.length === 0 && (
                                    <li className={styles.noResult}>Nenhum resultado</li>
                                  )}
                                  <li onClick={() => handleFabricanteSelect("")}>Todos</li>
                                  {fornecedoresFiltrados.map((f) => (
                                    <li
                                      key={f.fantasia}
                                      onClick={() => handleFornecedorSelect(f.fantasia)}
                                    >
                                      {f.fantasia}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </>
                      )}

                      <div className={styles.field}>
                        <label>Quantidade</label>
                        <div className={styles.inlineRow}>
                          <input type="number" min="0" placeholder="Mín" name="qtdeMin" value={filters.qtdeMin || ""} onChange={handleChange} />
                          <input type="number" min="0" placeholder="Máx" name="qtdeMax" value={filters.qtdeMax || ""} onChange={handleChange} />
                        </div>
                      </div>

                      <div className={styles.field}>
                        <label>Valor</label>
                        <div className={styles.inlineRow}>
                          <input type="text" placeholder="Mín" name="vlUnitMin" value={filters.vlUnitMin || ""} onChange={handleChange} />
                          <input type="text" placeholder="Máx" name="vlUnitMax" value={filters.vlUnitMax || ""} onChange={handleChange} />
                        </div>
                      </div>
                    </div>
                  </section>
                )}

                <br />

                <div className={styles.formButtons}>
                  <button type="button" className={styles.btnLimparFiltros} onClick={handleLimparFiltros}>Limpar filtros</button>
                  <button type="submit" className={styles.button}>Pesquisar</button>
                </div>
              </div>
            </form>
          </aside>

          <section className={styles.resultsPanel}>
            {isLoading ? (
              <Loading message={"Carregando dados de vendas..."} />
            ) : (
              <>
                {permissoes?.vendas?.solicitar_produtos && (
                  <div className={styles.btnSolicitarProdutos}>
                    <button onClick={() => navigate("/solicitacoes_distribuicao")}>
                      <img src="/images/common/documento.svg" alt="" />
                      Acompanhar Minhas Solicitações
                    </button>
                  </div>
                )}

                {anoVisivel && (
                  <p className={styles.correnteAno}>{anoVisivel}</p>
                )}

                <div className={styles.cardTotais}>
                  <div className={styles.brutoContainer}>
                    <span className={styles.label}>Valor Bruto</span>
                    <p className={styles.valorBruto}>
                      {formatarValor(totalValor) || 0}
                    </p>
                  </div>

                  {empresasValidasCustoMargem && (
                    <div className={styles.liquidosContainer}>
                      <div className={styles.liquidoBox}>
                        <span className={styles.label}>Subtotal 1</span>
                        <p className={styles.valorLiquido}>
                          {formatarValor(totalValorLiquido) || 0}
                        </p>
                        <span className={styles.subInfo}>(- % consultoras)</span>
                      </div>

                      <div className={styles.liquidoBox}>
                        <span className={styles.label}>Subtotal 2</span>
                        <p className={styles.valorLiquido}>
                          {formatarValor(totalValorLiquido2) || 0}
                        </p>
                        <span className={styles.subInfo}>(- % supervisoras)</span>
                      </div>

                      <div className={styles.liquidoBox}>
                        <span className={styles.label}>Líquido</span>
                        <p className={styles.valorLiquido}>
                          {formatarValor(totalValorLiquido3) || 0}
                        </p>
                        <span className={styles.subInfo}>(- custo escritório, 14% aproximadamente)</span>
                      </div>
                    </div>
                  )}

                  {permissoes?.vendas?.exibirCustoMargem && empresasValidasCustoMargem && (
                    <div className={styles.custoMargem}>
                      <span className={styles.label}>
                        Custo da Mercadoria:<br />
                        <strong style={{ fontSize: "1rem" }}>
                          {formatarValor(totalCusto) || 0}
                        </strong>
                      </span>

                      <span className={styles.label}>
                        Lucro sobre o Custo:<br />
                        <strong style={{ fontSize: "1rem" }}>
                          {Math.round(((totalValorLiquido3 - totalCusto) / totalCusto) * 100 || 0)}%
                          ({formatarValor((totalValorLiquido3 - totalCusto) || 0)})
                        </strong>
                      </span>
                    </div>
                  )}
                </div>

                <div className={styles.subTotais}>
                  <p className={styles.totalAtendimentos}>
                    <span className={styles.label}>Geral</span>
                    <p>
                      <strong>{formatarMilhares(totalAtendimentos) || 0}</strong>
                      vendas
                    </p>
                    <p style={{ marginTop: "8px" }}>
                      <strong>{formatarMilhares(totalQtd) || 0}</strong>
                      quantidade de peças
                    </p>
                    <p style={{ marginTop: "8px" }}>
                      <strong>{formatarMilhares(totalRegistros) || 0}</strong>
                      modelos de peças
                    </p>
                  </p>

                  <p className={styles.ticketMedioVenda}>
                    <span className={styles.label}>Ticket médio</span>
                    <p className={styles.value}>
                      <strong >{totalAtendimentos > 0 ? formatarValor(totalValor / totalAtendimentos) : formatarValor(0)}</strong>
                      &nbsp;Bruto
                    </p>
                    {empresasValidasCustoMargem && (
                      <p className={styles.value} style={{ marginTop: "8px" }}>
                        <strong>{totalAtendimentos > 0 ? formatarValor(totalValorLiquido / totalAtendimentos) : formatarValor(0)}</strong>
                        &nbsp;(- % consultora)
                      </p>
                    )}
                    {empresasValidasCustoMargem && (
                      <p className={styles.value} style={{ marginTop: "8px" }}>
                        <strong>{totalAtendimentos > 0 ? formatarValor(totalValorLiquido2 / totalAtendimentos) : formatarValor(0)}</strong>
                        &nbsp;(- % supervisora)
                      </p>
                    )}
                  </p>

                  <p className={styles.ticketMedioPeca}>
                    <span className={styles.label}>Média por peça</span>
                    <p className={styles.value}>
                      <strong>{totalQtd > 0 ? formatarValor(totalValor / totalQtd) : formatarValor(0)}</strong>
                      &nbsp;Bruto
                    </p>
                    {empresasValidasCustoMargem && (
                      <p className={styles.value} style={{ marginTop: "8px" }}>
                        <strong>{totalQtd > 0 ? formatarValor(totalValorLiquido / totalQtd) : formatarValor(0)}</strong>
                        &nbsp;(- % consultora)
                      </p>
                    )}
                    {empresasValidasCustoMargem && (
                      <p className={styles.value} style={{ marginTop: "8px" }}>
                        <strong>{totalQtd > 0 ? formatarValor(totalValorLiquido2 / totalQtd) : formatarValor(0)}</strong>
                        &nbsp;(- % supervisora)
                      </p>
                    )}
                  </p>
                </div>

                <div className={styles.rankingEmpresas}>
                  <div className={styles.rankingHeader}>
                    <h3 className={styles.rankingTitle}>👑 Ranking de Vendas</h3>
                    <button
                      type="button"
                      className={styles.rankToggle}
                      onClick={handleToggleRankingOrdenacao}
                    >
                      Ordenação atual: <b>{filters.rankingOrdenacao === "qtd" ? "Quantidade" : "Valor"}</b>
                    </button>
                  </div>

                  {!isLoading && (!rankingEmpresas || rankingEmpresas.length === 0) ? (
                    <div className={styles.rankingEmpty}>Nenhum dado para exibir com os filtros atuais.</div>
                  ) : (
                    <ol className={styles.rankingList}>
                      {rankingEmpresas?.map((item, idx) => {
                        const qtd = Number(item.total_qtd ?? 0);
                        const valor = Number(item.total_valor ?? 0);
                        const metricaAtual = filters.rankingOrdenacao === "qtd" ? qtd : valor;
                        const pct = Math.round((metricaAtual / maxRankingEmpresas) * 100);

                        const medal = idx === 0 ? "🥇" : idx === 1 ? "🥈" : idx === 2 ? "🥉" : "";
                        const open = !!empresasOpen[item.empresa_codigo];
                        const clientes = item.topClientes || [];

                        return (
                          <li key={`${item.empresa_codigo}-${idx}`} className={styles.rankingItem}>
                            <div className={styles.rankRow}>
                              <div className={styles.rankLeft}>
                                <span className={styles.rankPos}>{idx + 1}</span>
                                <span className={styles.rankMedal}>{medal}</span>
                                <span className={styles.rankEmpresa}>
                                  {item.empresa_nome} ({item.setor} {item.regiao})
                                </span>
                              </div>

                              <div className={styles.rankRight}>
                                <div className={styles.rankNums}>
                                  <span className={styles.rankValor}>
                                    {valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                  </span>
                                  <span className={styles.rankQtd}>{qtd} peças</span>

                                  <button
                                    type="button"
                                    className={styles.rankToggle}
                                    onClick={() => toggleEmpresa(item.empresa_codigo)}
                                    aria-expanded={open}
                                  >
                                    {open ? "Ocultar" : "Top 10 - Melhores Clientes"}
                                    <span className={`${styles.chev} ${open ? styles.chevOpen : ""}`}><FaChevronDown /></span>
                                  </button>
                                </div>

                                <div className={styles.rankBarWrap} aria-hidden="true">
                                  <div className={styles.rankBar} style={{ width: `${pct}%` }} />
                                </div>
                              </div>
                            </div>

                            {open && (
                              <div className={styles.clientesBox}>
                                {clientes.length === 0 ? (
                                  <div className={styles.clientesEmpty}>Sem clientes para esses filtros.</div>
                                ) : (
                                  <ol className={styles.clientesList}>
                                    {clientes.map((c, i) => {
                                      const v = Number(c.total_valor ?? 0);
                                      const q = Number(c.total_qtd ?? 0);
                                      return (
                                        <li key={`${item.empresa_codigo}-${c.cliente}-${i}`} className={styles.clienteItem}>
                                          <span className={styles.clienteNome}>{c.cliente || '(clientes sem cadastro)'}</span>
                                          <span className={styles.clienteValor}>
                                            {v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                          </span>
                                          <span className={styles.clienteQtd}>{q} peças</span>
                                        </li>
                                      );
                                    })}
                                  </ol>
                                )}
                              </div>
                            )}
                          </li>
                        );
                      })}
                    </ol>
                  )}
                </div>

                <div className={styles.rankingEmpresas}>
                  <div className={styles.rankingHeader}>
                    <h3 className={styles.rankingTitle}>💎 Ranking de Produtos</h3>
                    <button
                      type="button"
                      className={styles.rankToggle}
                      onClick={handleToggleRankingOrdenacao}
                    >
                      Ordenação atual: <b>{filters.rankingOrdenacao === "qtd" ? "Quantidade" : "Valor"}</b>
                    </button>
                  </div>

                  {!isLoading && (!rankingGruposPai || rankingGruposPai.length === 0) ? (
                    <div className={styles.rankingEmpty}>Nenhum dado para exibir com os filtros atuais.</div>
                  ) : (
                    <ol className={styles.rankingList}>
                      {rankingGruposPai?.map((item, idx) => {
                        const qtd = Number(item.total_qtd ?? 0);
                        const valor = Number(item.total_valor ?? 0);
                        const grupoPai = item.grupo_pai || "SEM GRUPO PAI";
                        const metricaAtual = filters.rankingOrdenacao === "qtd" ? qtd : valor;
                        const pct = Math.round((metricaAtual / maxRankingGruposPai) * 100);

                        const medal = idx === 0 ? "🥇" : idx === 1 ? "🥈" : idx === 2 ? "🥉" : "";
                        const open = !!gruposPaiOpen[grupoPai];
                        const grupos = item.topGrupos || [];

                        return (
                          <li key={`${grupoPai}-${idx}`} className={styles.rankingItem}>
                            <div className={styles.rankRow}>
                              <div className={styles.rankLeft}>
                                <span className={styles.rankPos}>{idx + 1}</span>
                                <span className={styles.rankMedal}>{medal}</span>
                                <span className={styles.rankEmpresa}>{grupoPai}</span>
                              </div>

                              <div className={styles.rankRight}>
                                <div className={styles.rankNums}>
                                  <span className={styles.rankValor}>
                                    {valor.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                  </span>
                                  <span className={styles.rankQtd}>{qtd} peças</span>

                                  <button
                                    type="button"
                                    className={styles.rankToggle}
                                    onClick={() => toggleGrupoPai(grupoPai)}
                                    aria-expanded={open}
                                  >
                                    {open ? "Ocultar" : "Top 10 - Grupos"}
                                    <span className={`${styles.chev} ${open ? styles.chevOpen : ""}`}><FaChevronDown /></span>
                                  </button>
                                </div>

                                <div className={styles.rankBarWrap} aria-hidden="true">
                                  <div className={styles.rankBar} style={{ width: `${pct}%` }} />
                                </div>
                              </div>
                            </div>

                            {open && (
                              <div className={styles.clientesBox}>
                                {grupos.length === 0 ? (
                                  <div className={styles.clientesEmpty}>Sem grupos para esses filtros.</div>
                                ) : (
                                  <ol className={styles.clientesList}>
                                    {grupos.map((g, i) => {
                                      const v = Number(g.total_valor ?? 0);
                                      const q = Number(g.total_qtd ?? 0);
                                      return (
                                        <li key={`${grupoPai}-${g.grupo}-${i}`} className={styles.clienteItem}>
                                          <span className={styles.clienteNome}>{g.grupo || "(sem grupo)"}</span>
                                          <span className={styles.clienteValor}>
                                            {v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}
                                          </span>
                                          <span className={styles.clienteQtd}>{q} peças</span>
                                        </li>
                                      );
                                    })}
                                  </ol>
                                )}
                              </div>
                            )}
                          </li>
                        );
                      })}
                    </ol>
                  )}
                </div>

                <div className={styles.resultsHeader}>
                  <h3 className={styles.produtosVendidos}>Produtos mais vendidos</h3>
                  <div className={styles.resultsActions}>
                    <button
                      type="button"
                      className={styles.downloadButton}
                      onClick={handleDownloadExcel}
                      disabled={isDownloading}
                    >
                      {isDownloading ? "Gerando..." : "Baixar Excel"}
                    </button>
                    <div className={styles.pagination}>
                      <button onClick={() => setPage(1)} disabled={page === 1}>Primeira</button>
                      <button onClick={() => setPage(page - 1)} disabled={page === 1}>&lt;</button>
                      <span>{page} de {totalPages}</span>
                      <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>&gt;</button>
                      <button onClick={() => setPage(totalPages)} disabled={page === totalPages}>Última</button>
                    </div>
                  </div>
                </div>

                <div className={styles.results}>
                  {results.map((item, idx) => (
                    <div key={idx} className={styles.card}>
                      <img
                        src={`https://provin.ind.br/api/imagem_produto/${item.cod_item.replace(/\//g, '+')}`}
                        alt={item.descr_longa || item.cod_item}
                        style={{ cursor: 'zoom-in' }}
                        onClick={() =>
                          abrirModal(`https://provin.ind.br/api/imagem_produto/${item.cod_item.replace(/\//g, '+')}`)
                        }
                      />
                      <p className={styles.qtdVendida}>{item.qtd_vendida} peças</p>
                      <p className={styles.valorVendido}>{formatarValor(item.vl_total)}</p>
                      <p className={styles.descricaoProduto}>{item.cod_item} - {item.descr_longa}</p>

                      {permissoes?.vendas?.solicitar_produtos && (
                        <button
                          className={styles.btnSolicitar}
                          onClick={() => abrirSolicitacao(item)}
                        >
                          Solicitar Reposição
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                <div className={styles.paginationFooter}>
                  <div className={styles.pagination}>
                    <button onClick={() => setPage(1)} disabled={page === 1}>Primeira</button>
                    <button onClick={() => setPage(page - 1)} disabled={page === 1}>&lt;</button>
                    <span>{page} de {totalPages}</span>
                    <button onClick={() => setPage(page + 1)} disabled={page === totalPages}>&gt;</button>
                    <button onClick={() => setPage(totalPages)} disabled={page === totalPages}>Última</button>
                  </div>
                </div>
              </>
            )}
          </section>
        </div>

        {modalSolicitar && (
          <div className={styles.modalOverlay}>
            <div className={styles.modal}>
              <button
                className={styles.btnFechar}
                onClick={() => setModalSolicitar(false)}
              >
                ✕
              </button>

              <h3>Solicitar Produto</h3>

              <div className={styles.modalProduto}>
                <strong>{produtoSelecionado?.cod_item}</strong>
                <br />
                {produtoSelecionado?.descr_longa}
              </div>

              <div className={styles.modalContent}>
                <div className={styles.fieldGroup}>
                  <label>Quantidade</label>

                  <div className={styles.qtdControl}>

                    <button
                      type="button"
                      className={styles.qtdBtn}
                      onClick={() =>
                        setQtdSolicitada(prev => Math.max(1, Number(prev) - 1))
                      }
                    >
                      −
                    </button>

                    <input
                      type="number"
                      min="1"
                      value={qtdSolicitada}
                      className={styles.qtdInput}
                      onChange={(e) =>
                        setQtdSolicitada(Math.max(1, Number(e.target.value)))
                      }
                    />

                    <button
                      type="button"
                      className={styles.qtdBtn}
                      onClick={() =>
                        setQtdSolicitada(prev => Number(prev) + 1)
                      }
                    >
                      +
                    </button>

                  </div>

                  <span className={styles.infoAuxiliar}>
                    Ajuste rapidamente usando os botões ou digitando.
                  </span>
                </div>

                <div className={styles.fieldGroup}>
                  <label>Anotação</label>
                  <textarea
                    value={anotacao}
                    onChange={(e) => setAnotacao(e.target.value)}
                    placeholder="Adicione uma observação opcional..."
                  />
                </div>

                <div className={styles.modalButtons}>
                  <button
                    className={styles.btnCancelar}
                    onClick={() => setModalSolicitar(false)}
                  >
                    Cancelar
                  </button>

                  <button
                    className={styles.btnConfirmar}
                    onClick={enviarSolicitacao}
                  >
                    Confirmar Solicitação
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <ImageModal
          isOpen={modalAberto}
          onRequestClose={fecharModal}
          contentLabel="Imagem Ampliada"
          className={styles.modalImagem}
          style={{
            overlay: { backgroundColor: 'rgba(0,0,0,0.85)' },
            content: {
              inset: 0,
              padding: 0,
              background: 'transparent',
              border: 'none',
            },
          }}
        >
          <div
            onClick={fecharModal}
            style={{
              width: '100vw',
              height: '100vh',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              cursor: 'zoom-out',
            }}
          >
            <img
              src={imagemSelecionada}
              alt="Imagem ampliada"
              style={{
                maxWidth: '100vw',
                maxHeight: '100vh',
                width: '100%',
                height: 'auto',
                objectFit: 'contain',
              }}
            />
          </div>
        </ImageModal>
      </div>
    </div >
  );
}

export default VendasAtacado;
